<template>
  <div style="position: relative">
    <h3 style="margin: 15px; text-align: center">
      Business Image
      <v-btn
        icon
        absolute
        v-if="!isEditStoreList"
        style="top: -5px; right: 15px"
      >
        <v-icon color="black" @click="toEdit()">edit</v-icon>
      </v-btn>
    </h3>
    <hr style="margin: 0 15px" />
    <div class="body__container">
      <v-layout wrap>
        <v-flex
          xs12
          sm6
          class="mt-1"
          v-for="(info, index) in store_detail.store_business_image"
          :key="index"
        >
          <a target="_blank" :href="info.store_business_image"
            ><v-img max-width="200px" :src="info.store_business_image"></v-img>
          </a>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title
          class="py-2"
          style="
            display: flex;
            font-size: 22px;
            background-color: black;
            color: white;
          "
          >Edit Business Image <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" :disabled="isLoading">
            <v-icon color="white">close</v-icon></v-btn
          ></v-card-title
        >
        <v-card-text>
          <div style="display: flex">
            <v-spacer> </v-spacer>
            <v-btn
              fab
              @click="$refs.imageInput.click()"
              color="black"
              style="color: white"
              ><v-icon>add</v-icon></v-btn
            >

            <input
              style="display: none"
              type="file"
              @change="onImageSelected"
              ref="imageInput"
              accept="image/*"
            />
          </div>

          <v-layout
            wrap
            class="body__items"
            style="max-height: 60vh; overflow: auto"
          >
            <v-flex
              xs12
              sm6
              class="pa-3"
              v-for="(image, index) in formImageData"
              :key="index"
              style="display: flex; position: relative"
            >
              <v-btn
                icon
                style="
                  position: absolute;
                  right: -5px;
                  top: -5px;
                  background-color: red;
                  z-index: 1;
                "
                @click="removeImage(index)"
              >
                <v-icon color="white" style="font-size: 16px">delete</v-icon>
              </v-btn>
              <v-img
                max-width="200px"
                :src="image.store_business_image"
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <!-- <v-card-actions>
          <v-btn
            style="width: 100%"
            color="primary"
            @click="save"
            :loading="isLoading"
            ><v-icon color="black">save</v-icon></v-btn
          ></v-card-actions
        > -->
        <v-card-actions
          ><v-spacer></v-spacer
          ><v-btn
            color="black"
            width="400px"
            style="color: white"
            @click="save"
            :loading="isLoading"
            >save</v-btn
          ><v-spacer></v-spacer
        ></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["store_detail"],
  data() {
    return {
      isLoading: false,
      dialog: false,
      formImageData: [],
    };
  },
  computed: {
    ...mapGetters(["isEditStoreList"]),
  },
  methods: {
    ...mapActions({
      editStoreBusinessImage: "fetchStoreBack/editStoreBusinessImage",
    }),
    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      let _this = this;
      reader.addEventListener("load", () => {
        _this.formImageData.push({ store_business_image: reader.result });
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    toEdit() {
      this.formImageData = JSON.parse(
        JSON.stringify(this.store_detail.store_business_image)
      );
      this.dialog = true;
    },
    removeImage(index) {
      this.formImageData.splice(index, 1);
    },
    async save() {
      this.isLoading = true;
      let payload = {
        store_id: this.store_detail.store.store_id,
        province: this.$route.params.province,
        form: {
          store_business_images: this.formImageData,
        },
      };
      let result = await this.editStoreBusinessImage(payload);
      //รอ response
      if (result === true) {
        await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.store_detail.store.store_id
        );
        this.dialog = false;
      }
      this.isLoading = false;
    },
  },
};
</script>

<style  scoped>
.style-title-detail {
  font-size: 15px;
  margin-bottom: 10px;
}

.style-data-detail {
  font-size: 15px;
  color: #616a6b;
}

.body__container {
  padding: 15px;
  max-height: 250px;
  overflow: auto;
}

.body__items::-webkit-scrollbar {
  display: none;
}
</style>